import { Button } from "antd";
import { Label, Modal, Drawer } from "flowbite-react";
import React, { useEffect, useState, useRef } from "react";
import TextEditor from "./TextEditor";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "./Loader";
import { Remarkable } from "remarkable";
import TweetCard from "../components/TweetCard";
import useCommonApi from "../hooks/common-apis";
import FailureModal from "./FailureModal";
import SuccessModal from "./SuccessModal";
import ThreeDotsLoader from "./ThreeDotsLoader";
import SocialConnectModal from "./SocialConnectModal";
import { toast } from "react-toastify";
import { clog } from "../lib/utils";

const EditableTableAgent = ({
  agentResponseData,
  lastElementRef,
  loadingIndividualAgent,
  getAgentData,
  taskData,
  settaskData,
  handleChangeInput,
  tagskeywords,
  removeTagkeywords,
  inputValuekeywords,
  setInputValuekeywords,
  handleKeyDownkeywords,
  loading,
  rerunPopup,
  setrerunPopup,
  fetchIndividualAgentContent,
  checkKnowledgeBase,
}) => {
  const { checkTwitterAccess } = useCommonApi();
  const [knowledgeBaseRowsCopied, setknowledgeBaseRowsCopied] = useState([]);
  const [data, setData] = useState([[]]);
  const [headerData, setheaderData] = useState([
    "Instruction",
    "Title",
    "Content",
    "Status",
    "Keyword",
    "Published URL",
    "URL Indexed",
    "Index Details",
    "X",
    "linkedIn",
  ]);
  const [selectedRowIndex, setselectedRowIndex] = useState(null);
  clog(selectedRowIndex, "selectedRowIndex");
  const [connectModal, setConnectModal] = useState(false);
  const [linkedInconnectModal, setlinkedInConnectModal] = useState(false);
  const [selectedRow, setselectedRow] = useState({});
  const [twitterProfile, setTwitterProfile] = useState({});
  const [linkedInPostMessage, setlinkedInPostMessage] = useState("");
  const [isChecking, setisChecking] = useState(false);
  const [openSuccessModal, setopenSuccessModal] = useState(undefined);
  const [openFailureModal, setopenFailureModal] = useState(undefined);
  const [successFailureMessage, setsuccessFailureMessage] = useState("");
  const removeModal = () => {
    setopenSuccessModal(undefined);
    setopenFailureModal(undefined);
  };
  const [numberOfTweets, setnumberOfTweets] = useState("");
  const [openXPopup, setopenXPopup] = useState({});
  const [generateClicked, setgenerateClicked] = useState({});
  const [rowsData, setrowsData] = useState([["", "", ""]]);
  // first index is header
  // next  index is data means each row
  const [closeOpen, setcloseOpen] = useState(false);
  const [openUrl, setOpenUrl] = useState(false);
  const [publishedUrls, setPublishedUrls] = useState([]);
  const [closeOpenContent, setcloseOpenContent] = useState(false);
  const [editingCell, setEditingCell] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCols, setSelectedCols] = useState([]);
  const [newColumnsList, setnewColumnsList] = useState([]);
  const [stringOutput, setstringOutput] = useState([]);
  const [stringOutputContent, setstringOutputContent] = useState("");
  const [textContent, settextContent] = useState("");
  const [editSave, seteditSave] = useState(false);
  const [selectedCell, setselectedCell] = useState({
    rowIndex: null,
    colIndex: null,
  });
  const [renameClicked, setrenameClicked] = useState(false);
  const [addColumnClicked, setaddColumnClicked] = useState(false);
  const [addName, setaddName] = useState("");
  const navigate = useNavigate();

  // Add a new row
  // const addRow = () => {
  //   setData((prevData) => [...prevData, Array(prevData[0].length).fill("")]);
  //   setrowsData((prevData) => [...prevData, Array(prevData[0].length).fill("")]);
  //   setEditingCell({ rowIndex: rowsData.length, colIndex: 0 });
  // };

  // Add a new column
  // const addColumn = () => {
  //   // setData((prevData) => prevData.map((row) => [...row, ""]));

  //   // callSaveApi("addColumn");
  //   // setEditingCell({ rowIndex: 0, colIndex: headerData.length });
  // };

  // Delete selected rows
  // const deleteSelectedRows = () => {
  //   setData((prevData) =>
  //     prevData.filter((_, index) => !selectedRows.includes(index))
  //   );
  //   setSelectedRows([]); // Clear selection after deletion
  // };
  clog(headerData, "headerData");

  // Delete selected columns
  // const deleteSelectedCols = () => {
  //   // setData((prevData) =>
  //   //   prevData.map((row) =>
  //   //     row.filter((_, index) => !selectedCols.includes(index))
  //   //   )
  //   // );
  //   // setSelectedCols([]); // Clear selection after deletion

  //   // deleteSelectedColumn();
  //   setheaderData((prevData) =>
  //     prevData.filter((_, index) => index !== editingCell?.colIndex)
  //   );
  //   setrowsData((prevData) =>
  //     prevData.map((row) =>
  //       row.filter((_, index) => index !== editingCell?.colIndex)
  //     )
  //   );
  // };

  // Handle cell click to enable editing
  const handleCellClick = (rowIndex, colIndex) => {
    setEditingCell({ rowIndex, colIndex });
  };

  // Handle change in cell value
  const handleChange = (e, rowIndex, colIndex) => {
    const newValue = e.target.value;
    setData((prevData) => {
      const newData = [...prevData];
      newData[rowIndex][colIndex] = newValue;
      return newData;
    });
  };
  const [generatingTweet, setgeneratingTweet] = useState(false);
  const [tweets, settweets] = useState([]);
  const [tweetsModified, settweetsModified] = useState([]);
  const [edited, setedited] = useState(false);
  const callSaveApi = async (array, type) => {
    try {
      let data = {
        content_id: selectedRow?.id,
        [type]: array,
      };
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/content_update`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      if (!response.data.error) {
        if (type === "content") return;
        fetchIndividualAgentContent(selectedRow?.id);
      } else {
      }
    } catch (error) {
      clog(error);
    }
  };
  const callSaveApiUpdate = (data, index, type) => {
    let array = [...tweets];
    array[index] = data;
    settweets(array);
    callSaveApi(array, type);
  };
  clog(selectedRow, "selected row");
  const callGenerateFn = async (type, title) => {
    if (!numberOfTweets) {
      // notify("Please enter the number of tweets", "error");
      return;
    }
    try {
      let data = {
        blog: selectedRow?.content,
        no_result: parseInt(numberOfTweets),
      };
      let url = "";
      if (type === "Twitter") {
        url = `${process.env.REACT_APP_TWITTER_URL}/get_tweet`;
      } else {
        url = `${process.env.REACT_APP_LINKEDIN_URL}/get_linkedin_post`;
      }

      setgeneratingTweet(true);
      clog(data, url, type, "data,url,type");
      const response = await axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      setgeneratingTweet(false);
      let content = response?.data?.response;
      if (content === "") {
        notify("No Posts generated Please try again!", "error");
        return;
      }
      if (type === "Twitter") {
        // const normalizedContent = content?.replace(/\n+/g, "\n");
        let splittedContent = content?.split("$$$")?.map((item) => {
          let trimmedItem = item?.trim();
          return {
            content: trimmedItem,
            id: "",
            db_id: "",
            schedule_datetime: "",
            user_timezone: "",
            media: {},
          };
        });
        clog(splittedContent, "splittedContent");
        callSaveApi(splittedContent, "twitter");
        clog("Call Save Api");
        settweets(splittedContent);
        settweetsModified(splittedContent);
      } else {
        let splittedContent = content?.split("$$$")?.map((item) => {
          let trimmedItem = item?.trim();
          return {
            content: trimmedItem,
            id: "",
            db_id: "",
            schedule_datetime: "",
            user_timezone: "",
            media: {},
          };
        });
        clog(splittedContent, "splittedContent");
        callSaveApi(splittedContent, "linkedin");
        clog("Call Save Api");
        settweets(splittedContent);
        settweetsModified(splittedContent);
      }
      setopenXPopup({});
      let headline;
      if (type === "Twitter") {
        headline = "Tweets";
      } else if (type === "LinkedIn") {
        headline = "LinkedIn";
      } else {
        headline = "";
      }
      setgenerateClicked({
        open: true,
        headline: headline,
        title: title,
      });
      // setopenXPopup(false);
      // if (!response.data.error) {
      //   setopenSuccessModal(true);
      //   setsuccessFailureMessage("Task Generated Successfully");
      //   setgenerateClicked(false);
      // } else {
      //   setopenFailureModal(true);
      //   setsuccessFailureMessage("Task Generation Failed");
      //   setgenerateClicked(false);
      // }
    } catch (error) {
      clog(error);
      setgeneratingTweet(false);
    }
  };
  const getData = (headline) => {
    let profile;
    let method;
    if (headline === "Tweets") {
      profile = twitterProfile;
      method = handleTwitterLogin;
    } else if (headline === "LinkedIn") {
      profile = JSON.parse(localStorage.getItem("linkedin_access"));
      method = integrateLinkedIn;
    } else {
      profile = {};
      method = () => {};
    }
    return {
      profile,
      method,
    };
  };
  // clog(editingCell, "editingCell");
  // const callSaveApi = async (from = "normal") => {
  //   clog("coming here", editingCell);
  //   // clog(id);
  //   try {
  //     let data = {};
  //     if (from === "addColumn") {
  //       let newColumnName = addName;
  //       setheaderData((prevData) => [...prevData, newColumnName]);
  //       setrowsData((prevData) => prevData.map((row) => [...row, ""]));
  //       let column_no_global = 0;
  //       for (let i = 0; i < newColumnsList.length; i++) {
  //         let column_no = newColumnsList[i].column_no;
  //         column_no_global = Math.max(column_no_global, column_no);
  //       }
  //       setnewColumnsList((prevData) => [
  //         ...prevData,
  //         {
  //           head_name: newColumnName,
  //           column_no: column_no_global + 1,
  //           new: true,
  //         },
  //       ]);
  //       let knowledgebase_data = JSON.parse(
  //         localStorage.getItem("selected-knowledge-base")
  //       );
  //       let knowledgeBaseRowsData = knowledgeBaseRows?.data;
  //       data["column_head"] = {
  //         head_name: newColumnName,
  //         column_no: column_no_global + 1,
  //       };
  //       data["knowledge_id"] = knowledgebase_data?.knowledge_id;
  //       data["id"] = knowledgeBaseRowsData[0].id;
  //     } else {
  //       if (!editingCell) return;
  //       let knowledgebase_data = JSON.parse(
  //         localStorage.getItem("selected-knowledge-base")
  //       );
  //       let knowledgeBaseRowsData = knowledgeBaseRows?.data;
  //       let selectedRowData = knowledgeBaseRowsData[editingCell.rowIndex - 1];
  //       clog(selectedRowData, "selectedRowData");
  //       if (editingCell?.rowIndex !== 0) {
  //         data["id"] = selectedRowData.id;
  //       } else {
  //         data["id"] = knowledgeBaseRowsData[0].id;
  //       }
  //       let header = newColumnsList[editingCell.colIndex]?.head_name;
  //       let value =
  //         editingCell?.rowIndex !== 0
  //           ? rowsData[editingCell?.rowIndex - 1][editingCell?.colIndex]
  //           : "";
  //       clog(value, "value");
  //       if (editingCell?.rowIndex !== 0 && !value) {
  //         setEditingCell(null);
  //         return;
  //       }
  //       if (!newColumnsList[editingCell?.colIndex]?.new) {
  //         data[header] = value;
  //       } else {
  //         if (editingCell?.rowIndex !== 0) {
  //           let column_data = {};
  //           column_data["column_no"] =
  //             newColumnsList[editingCell?.colIndex].column_no;
  //           column_data["data_value"] = value;
  //           data["column_data"] = column_data;
  //         } else {
  //           let column_head = {};
  //           column_head["column_no"] =
  //             newColumnsList[editingCell?.colIndex].column_no;
  //           column_head["head_name"] = header;
  //           data["column_head"] = column_head;
  //         }
  //       }
  //       data["knowledge_id"] = knowledgebase_data?.knowledge_id;
  //       setheaderData((prevData) =>
  //         prevData.map((item, index) =>
  //           index === editingCell?.colIndex
  //             ? newColumnsList[editingCell?.colIndex]?.head_name
  //             : item
  //         )
  //       );
  //       clog(data, "data");
  //       setEditingCell(null);
  //       setaddColumnClicked(false);
  //       setrenameClicked(false);
  //       setaddName("");
  //     }
  //     setaddColumnClicked(false);
  //     setaddName("");
  //     // return;
  //     const response = await axios({
  //       url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/knowledgebase_update`,
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         jwt_token: localStorage.getItem("login_token"),
  //       },
  //       data: data,
  //     });
  //     if (!response.data.error) {
  //       // clog(response.data);
  //     } else {
  //     }
  //   } catch (error) {
  //     clog(error);
  //     if (error.response && error?.response?.status == 401) {
  //       localStorage.removeItem("login_token");
  //       localStorage.removeItem("login_data");
  //       navigate("/");
  //     }
  //   }
  // };
  // // clog(addColumnClicked, "addColumnClicked");
  // const deleteSelectedColumn = async () => {
  //   // clog(id);
  //   try {
  //     let knowledgebase_data = JSON.parse(
  //       localStorage.getItem("selected-knowledge-base")
  //     );
  //     let knowledgeBaseRowsData = knowledgeBaseRows?.data;
  //     let data = {};
  //     data["knowledge_id"] = knowledgebase_data?.knowledge_id;
  //     let selectedColumn = editingCell?.colIndex;
  //     let column_no = newColumnsList[selectedColumn].column_no;
  //     data["column_no"] = column_no;
  //     // return;
  //     setnewColumnsList((prevData) =>
  //       prevData.filter((item) => item.column_no != column_no)
  //     );
  //     setSelectedCols([]); // Clear selection;
  //     setEditingCell(null);

  //     const response = await axios({
  //       url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/knowledgebase_columndelete`,
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         jwt_token: localStorage.getItem("login_token"),
  //       },
  //       data: data,
  //     });
  //     if (!response.data.error) {
  //       // clog(response.data);
  //     } else {
  //     }
  //   } catch (error) {
  //     clog(error);
  //     if (error.response && error?.response?.status == 401) {
  //       localStorage.removeItem("login_token");
  //       localStorage.removeItem("login_data");
  //       navigate("/");
  //     }
  //   }
  // };
  clog(newColumnsList, "newColumnsList");

  // Handle blur event to stop editing
  // const handleBlur = (from) => {
  //   callSaveApi(from);
  // };

  // Handle row selection
  // const handleRowSelection = (rowIndex) => {
  //   setSelectedRows((prevSelected) =>
  //     prevSelected.includes(rowIndex)
  //       ? prevSelected.filter((i) => i !== rowIndex)
  //       : [...prevSelected, rowIndex]
  //   );
  // };

  // Handle column selection
  // const handleColSelection = (colIndex) => {
  //   setSelectedCols((prevSelected) =>
  //     prevSelected.includes(colIndex)
  //       ? prevSelected.filter((i) => i !== colIndex)
  //       : [...prevSelected, colIndex]
  //   );
  // };
  // const handleAddColumn = (colIndex) => {
  //   const updatedData = data.map((row) => {
  //     const newRow = [...row];
  //     newRow.splice(colIndex + 1, 0, ""); // Insert an empty cell to the right
  //     return newRow;
  //   });
  //   setData(updatedData); // Update the state
  // };
  function capitalizeWords(input) {
    if (input === "content_url") {
      return "URL";
    }
    return input
      .split("_") // Split the string by underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the words back with spaces
  }
  const checkDisplayCheckboxes = (colIndex) => {
    if (selectedCols.length > 0) {
      if (selectedCols.includes(colIndex)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  // const getInitialData = () => {
  //   let knowledgeBaseRowsData = knowledgeBaseRows?.data;
  //   const header = Object.keys(knowledgeBaseRowsData[0]);
  //   let noNeedColumns = [
  //     "id",
  //     "workspace_id",
  //     "knowledge_id",
  //     "user_id",
  //     "doc_type",
  //     "status",
  //     "createdAt",
  //     "updatedAt",
  //     "custom_fields",
  //     "__v",
  //     "knowledgedata",
  //   ];
  //   let standardColumns = header.filter(
  //     (item) => !noNeedColumns.includes(item)
  //   );
  //   let newColumns = [...standardColumns];
  //   let knowledgehead = knowledgeBaseRows?.knowledgehead;
  //   for (let i = 0; i < knowledgehead.length; i++) {
  //     if (!newColumns.includes(knowledgehead[i].head_name)) {
  //       newColumns.push(knowledgehead[i].head_name);
  //     }
  //   }
  //   let newRows = knowledgeBaseRowsData.map((row, row_index) => {
  //     let newRow = [];
  //     standardColumns.forEach((item) => {
  //       newRow.push(row[item]);
  //     });
  //     for (let i = 0; i < knowledgehead.length; i++) {
  //       let knowledgedata = knowledgeBaseRowsData[row_index]?.knowledgedata;
  //       let knowledgedataIndex = knowledgedata.findIndex(
  //         (item) => item.column_no === knowledgehead[i].column_no
  //       );
  //       if (knowledgedataIndex !== -1) {
  //         newRow.push(knowledgedata[knowledgedataIndex].data_value);
  //       } else {
  //         newRow.push("");
  //       }
  //     }

  //     return newRow;
  //   });
  //   clog(newRows, "newRows");
  //   setnewColumnsList(knowledgehead);
  //   setheaderData(newColumns || []);
  //   setrowsData(newRows || []);
  //   setknowledgeBaseRowsCopied(knowledgeBaseRowsData);
  // };
  // const getInitialData = () => {
  //   let knowledgeBaseRowsData = knowledgeBaseRows?.data;
  //   const header = Object.keys(knowledgeBaseRowsData[0] || "{}");
  //   let noNeedColumns = [
  //     "id",
  //     "workspace_id",
  //     "knowledge_id",
  //     "user_id",
  //     "doc_type",
  //     "status",
  //     "createdAt",
  //     "updatedAt",
  //     "custom_fields",
  //     "__v",
  //     "knowledgedata",
  //   ];
  //   let standardColumns = header.filter(
  //     (item) => !noNeedColumns.includes(item)
  //   );
  //   let newColumns = [...standardColumns];
  //   let knowledgehead = knowledgeBaseRows?.knowledgehead;
  //   for (let i = 0; i < knowledgehead.length; i++) {
  //     if (!newColumns.includes(knowledgehead[i].head_name)) {
  //       newColumns.push(knowledgehead[i].head_name);
  //     }
  //   }
  //   let newRows = knowledgeBaseRowsData.map((row, row_index) => {
  //     let newRow = [];
  //     standardColumns.forEach((item) => {
  //       newRow.push(row[item]);
  //     });
  //     for (let i = 0; i < knowledgehead.length; i++) {
  //       let knowledgedata = knowledgeBaseRowsData[row_index]?.knowledgedata;
  //       let knowledgedataIndex = knowledgedata.findIndex(
  //         (item) => item.column_no === knowledgehead[i].column_no
  //       );
  //       if (knowledgedataIndex !== -1) {
  //         newRow.push(knowledgedata[knowledgedataIndex].data_value);
  //       } else {
  //         newRow.push("");
  //       }
  //     }

  //     return newRow;
  //   });
  //   // clog(newRows, "newRows");
  //   // adding old header to new column list with new:false
  //   let newColumnList = [];
  //   for (let i = 0; i < standardColumns.length; i++) {
  //     newColumnList.push({
  //       head_name: standardColumns[i],
  //       column_no: 0,
  //       new: false,
  //     });
  //   }
  //   // adding new header to new column list with new:true
  //   for (let i = 0; i < knowledgehead.length; i++) {
  //     newColumnList.push({
  //       head_name: knowledgehead[i].head_name,
  //       column_no: knowledgehead[i].column_no,
  //       new: true,
  //     });
  //   }
  //   setnewColumnsList(newColumnList);
  //   setheaderData(newColumns || []);
  //   setrowsData(newRows || []);
  //   setknowledgeBaseRowsCopied(knowledgeBaseRowsData);
  // };
  // useEffect(() => {
  //   if (Object.keys(knowledgeBaseRows || {})?.length > 0) {
  //     // getInitialData();
  //   }
  // }, [Object.keys(knowledgeBaseRows || {})?.length]);
  // clog(data, "data");
  // clog(headerData, "headerData");
  // clog(rowsData, "rowsData");
  // Add a ref for the popup
  const popupRef = useRef(null);
  const textAreaRef = useRef(null);
  const tableRef = useRef(null); // Ref for the entire table
  const drawerRef = useRef(null);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     // Check if click is outside the table
  //     if (tableRef.current && !tableRef.current.contains(event.target)) {
  //       clog("Clicked outside the editable table");
  //       setaddColumnClicked(false);
  //       if (editingCell?.rowIndex === 0) {
  //         setEditingCell(null);
  //         return;
  //       }
  //       callSaveApi("normal");
  //     }
  //   };

  //   // Attach the event listener for clicks
  //   document.addEventListener("click", handleClickOutside);

  //   // Cleanup the event listener on component unmount
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside);
  //   };
  // }, [tableRef, editingCell?.rowIndex, editingCell?.colIndex]);
  const notify = (message, type) =>
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      type: type,
    });
  useEffect(() => {
    if (editingCell?.rowIndex === 0) return;
    if (
      selectedCell?.rowIndex !== editingCell?.rowIndex ||
      selectedCell?.colIndex !== editingCell?.colIndex
    ) {
      // callSaveApi("normal");
    }
  }, [
    selectedCell?.rowIndex,
    selectedCell?.colIndex,
    editingCell?.rowIndex,
    editingCell?.colIndex,
  ]);
  const getRemarkableText = (text) => {
    // let string=stringOutput?.replaceAll(/\n/g, "<br/>");
    const md = new Remarkable();
    md.set({
      html: true,
      breaks: true,
      linkify: true,
      typographer: true,
      quotes: "“”‘’",
      xhtmlOut: true,
      langPrefix: "language-",
    });
    const html = md.render(text || "");
    return html;
  };
  useEffect(() => {
    if (Object.keys(agentResponseData || {}).length > 0) {
      let agentResponseDataTemp = {
        title: "Advancement in LLM with Recent Research Papers and Findings",
        content:
          "The field of Large Language Models (LLMs) has seen remarkable advancements in recent years, driven by innovative research and technological breakthroughs. This blog explores the latest findings and research papers that have significantly contributed to the evolution of LLMs, highlighting their implications and future directions.\n\nOne of the most notable advancements in LLMs is the development of more efficient training techniques. Recent research has focused on reducing the computational resources required to train these models without compromising their performance. For instance, techniques such as model distillation and pruning have gained traction, allowing researchers to create smaller, faster models that maintain high accuracy. A paper published in 2023 demonstrated that by applying these techniques, researchers could reduce the size of a model by 50% while retaining 95% of its original performance.\n\nAnother significant area of research is the exploration of multi-modal LLMs, which integrate text with other forms of data, such as images and audio. This approach has opened new avenues for applications in fields like healthcare, where models can analyze patient data in various formats. A recent study highlighted the success of a multi-modal LLM in diagnosing medical conditions by processing both textual patient histories and imaging data, showcasing the potential for improved accuracy in medical diagnostics.\n\nFurthermore, the ethical implications of LLMs have become a focal point in recent research. As these models become more powerful, concerns about bias, misinformation, and privacy have emerged. Researchers are actively working on frameworks to mitigate these issues, ensuring that LLMs are developed and deployed responsibly. A 2023 paper proposed a new methodology for auditing LLMs for bias, providing a systematic approach to identify and address potential ethical concerns in model training and deployment.\n\nThe scalability of LLMs is another critical area of advancement. Recent findings suggest that scaling up model parameters can lead to significant improvements in performance. However, this comes with challenges related to energy consumption and environmental impact. Researchers are now exploring sustainable practices in LLM development, such as using renewable energy sources for training and optimizing algorithms to reduce energy usage. A groundbreaking study in 2023 introduced a new training algorithm that reduced energy consumption by 30% while improving model performance, setting a precedent for future research in sustainable AI.\n\nIn conclusion, the advancements in Large Language Models are a testament to the rapid progress in AI research. With ongoing studies focusing on efficiency, multi-modal capabilities, ethical considerations, and sustainability, the future of LLMs looks promising. As researchers continue to push the boundaries of what these models can achieve, we can expect to see even more innovative applications that will transform industries and enhance our daily lives. The journey of LLMs is just beginning, and the potential for future breakthroughs is limitless.",
        review:
          "The content effectively covers the recent advancements in Large Language Models (LLMs) by discussing key areas such as training efficiency, multi-modal capabilities, ethical considerations, and sustainability. It is well-structured, informative, and aligns with the user's request for a 500-word blog. The tone is professional and engaging, making it suitable for an audience interested in AI research.",
        usage: {
          total_cost: 0,
          "gpt-4o-mini-2024-07-18": {
            cost: 0,
            prompt_tokens: 985,
            completion_tokens: 671,
            total_tokens: 1656,
          },
        },
      };
      // setData([
      //   ["title", "content"],
      //   [
      //     agentResponseData?.title,
      //     agentResponseData?.content?.substring(0, 100) + "...",
      //   ],
      // ]);
      // setrowsData([
      //   [agentResponseData?.title || "", agentResponseData?.content || "", ""],
      // ]);
      // setstringOutputContent(
      //   `## Title \n ${agentResponseData?.title || ""}\n\n ## Content \n ${
      //     agentResponseData?.content || ""
      //   }\n\n ## Review \n ${agentResponseData?.review || ""}`
      // );

      //setting row data according to new sudhir sir response
    }
  }, [Object.keys(agentResponseData || {}).length]);
  // let example = {
  //   title: "Fintech App Development: Innovative Solutions by Infiniticube",
  //   content:
  //     "Fintech App Development: Innovative Solutions by Infiniticube\n\n### Introduction to Fintech App Development\nIn today's digital economy, fintech app development has emerged as a critical component for businesses looking to innovate and enhance their financial services. The significance of fintech apps lies in their ability to provide seamless user experiences, streamline financial transactions, and offer personalized financial solutions. As the demand for mobile banking and digital financial services continues to rise, companies like Infiniticube are at the forefront of this transformation, leveraging their expertise to deliver cutting-edge fintech applications. The fintech landscape is characterized by rapid technological advancements and evolving consumer expectations, presenting both challenges and opportunities for developers. Businesses must navigate regulatory complexities, ensure data security, and create user-friendly interfaces to succeed in this competitive market.\n\n### Services Offered by Infiniticube\nInfiniticube specializes in a range of services that cater to the evolving needs of the fintech industry:\n\n1. **Fintech App Development**: Infiniticube develops robust fintech applications that are tailored to meet the specific requirements of clients, ensuring high performance and security. For instance, their work with BeMyShopper involved creating an app that seamlessly integrates online and offline shopping experiences, enhancing user engagement and satisfaction.\n2. **Mobile Banking Apps**: With the increasing reliance on mobile devices, Infiniticube creates intuitive mobile banking applications that enhance user engagement and provide essential banking services at users' fingertips. Their mobile banking solutions prioritize security and user experience, ensuring that customers can manage their finances with confidence.\n3. **DevOps Consulting**: Infiniticube offers DevOps consulting services to streamline development processes, improve collaboration, and accelerate the delivery of high-quality fintech solutions. By implementing best practices in DevOps, Infiniticube helps clients reduce time-to-market and enhance product quality.\n\nThe emphasis on high-quality services and collaboration in projects ensures that Infiniticube remains a trusted partner in fintech app development.\n\n### Current Trends in Fintech App Development\nThe fintech industry is continuously evolving, and several trends are shaping its future in 2023:\n1. **Artificial Intelligence (AI) and Machine Learning (ML)**: AI and ML are revolutionizing fintech by enabling predictive analytics, chatbots for customer support, and robotic process automation for efficiency. For example, predictive analytics can help users make informed investment decisions based on historical data and trends.\n2. **Personalization**: Leveraging data analytics, fintech apps are increasingly offering personalized experiences based on user behavior and preferences. This trend not only enhances user satisfaction but also drives customer loyalty.\n3. **Digital Banking**: The rise of digital-only banks is transforming the financial landscape, integrating technologies like blockchain for enhanced security. These banks offer a wide range of services without the overhead costs associated with traditional banking.\n4. **Open Banking APIs**: These APIs facilitate data exchange and user authentication, fostering innovation in financial services. They allow third-party developers to create applications that can interact with bank data, leading to more innovative solutions.\n5. **Enhanced User Experience (UX)**: Real-time notifications and social features are becoming standard in fintech apps, improving user engagement. A focus on UX design ensures that users can navigate apps easily and access the information they need quickly.\n6. **Mobile App Development**: A focus on mobile banking and advanced security measures is crucial for fintech companies. As mobile usage continues to rise, developing secure and user-friendly mobile applications is essential for success.\n7. **Blockchain and Cryptocurrency**: Integration of blockchain technology enhances security and efficiency in financial transactions. This technology provides transparency and reduces the risk of fraud, making it an attractive option for fintech solutions.\n8. **Regulatory Focus on Security and Transparency**: Compliance with regulations is paramount, leading to the adoption of advanced technologies for fraud prevention. Fintech companies must stay ahead of regulatory changes to ensure their solutions remain compliant.\n9. **Collaborative Ecosystems**: Cooperation between financial organizations is essential for driving innovation and expanding service offerings. Collaborative efforts can lead to the development of new products and services that meet the evolving needs of consumers.\n\nInfiniticube is adapting to these trends by incorporating AI and ML into their solutions, ensuring they remain competitive and innovative in the fintech space. By staying abreast of industry developments, Infiniticube can provide clients with the most relevant and effective solutions.\n\n### The Role of Machine Learning in Fintech\nMachine learning plays a pivotal role in fintech app development. Infiniticube integrates ML models to enhance user experiences, improve decision-making, and automate processes. Successful implementations include predictive analytics for investment strategies and personalized financial advice, showcasing the transformative power of ML in fintech applications. For instance, Infiniticube developed a financial advisory app that uses ML algorithms to analyze user data and provide tailored investment recommendations, significantly improving user engagement and satisfaction.\n\n### Importance of Collaboration in Fintech App Development\nCollaboration is vital in fintech app development for several reasons:\n1. **Access to Expertise and Resources**: Collaborating with established firms provides access to industry knowledge and resources, facilitating innovation. This partnership allows fintech startups to leverage the experience of seasoned professionals in the financial sector.\n2. **Regulatory Support**: Working with regulators ensures compliance and reduces risks, allowing for safe innovation. Regulatory sandboxes enable fintech companies to test their products in a controlled environment, fostering creativity while adhering to legal requirements.\n3. **Increased Customer Reach**: Partnerships expand customer bases, accelerating growth for fintech startups. By aligning with established financial institutions, fintech companies can tap into existing customer networks and enhance their market presence.\n4. **Holistic Solutions**: Collaboration fosters the development of comprehensive solutions that address complex financial challenges. By combining expertise from various sectors, fintech companies can create products that meet diverse customer needs.\n5. **Enhanced Security and User-Centricity**: By leveraging the strengths of both traditional and modern financial institutions, collaboration leads to more secure and user-friendly services. This synergy ensures that customer data is protected while providing a seamless user experience.\n\n### Conclusion\nInfiniticube's contributions to fintech app development are significant, as they continue to innovate and adapt to the changing landscape. For potential clients looking to explore fintech app development, Infiniticube offers a wealth of expertise and a commitment to delivering high-quality solutions. By choosing Infiniticube, clients can benefit from tailored fintech applications that meet their specific needs and drive business growth. Contact Infiniticube at info@infiniticube.com or call +1 415-800-2907 for more information.",
  //   review:
  //     "The blog effectively covers the topic of fintech app development with a focus on Infiniticube's expertise and services. It meets the 1000-word requirement and follows the provided outline, maintaining a logical flow. The content is engaging, informative, and aligns with Infiniticube's brand voice. The conclusion includes a strong call to action, encouraging potential clients to reach out. Overall, the blog is well-written and meets all requirements.",
  // };
  let example = {
    title:
      "Understanding the Cost of Fintech Mobile App Development with Infiniticube in 2025",
    content:
      "# Understanding the Cost of Fintech Mobile App Development with Infiniticube in 2025\n\n## 1. Introduction to Fintech Mobile App Development\nIn 2025, the fintech mobile app development landscape is expected to be shaped by several key trends. These include the integration of artificial intelligence (AI), generative AI, chatbots, blockchain technology, and robotic process automation (RPA). The focus will be on enhancing personalization, security, and automation in financial services, making it essential for businesses to stay ahead of the curve. As the fintech industry continues to evolve, it is projected to reach a market size of over $332.5 billion by 2028, growing at a CAGR of 20.3%. This growth underscores the importance of developing innovative and secure mobile applications that cater to the needs of consumers and businesses alike.\n\n### Current Trends in Fintech Mobile App Development\n- **AI Integration**: AI is revolutionizing the fintech sector by providing personalized user experiences. For instance, AI algorithms can analyze user behavior to offer tailored financial advice, making banking more intuitive and user-friendly. Companies like Wealthfront and Betterment are already using AI to provide personalized investment advice based on individual financial goals.\n- **Generative AI**: This technology is enabling hyper-personalization in fintech apps. By analyzing vast amounts of data, generative AI can create customized financial plans for users, enhancing their engagement with the app. For example, a fintech app could use generative AI to suggest personalized savings plans based on a user's spending habits.\n- **Chatbots**: AI-powered chatbots are becoming essential for customer service in fintech. They provide 24/7 support, answering queries and assisting users with transactions, which significantly improves user satisfaction. Banks like Bank of America have implemented chatbots like Erica to help customers manage their finances more effectively.\n- **Blockchain**: This technology ensures secure and transparent transactions. For example, blockchain can be used to verify identities and prevent fraud, which is crucial in the financial sector. Companies like Ripple are leveraging blockchain to facilitate cross-border payments securely and efficiently.\n- **Robotic Process Automation (RPA)**: RPA is streamlining operations by automating repetitive tasks, such as data entry and transaction processing, thereby increasing efficiency and reducing operational costs. Financial institutions are increasingly adopting RPA to enhance their operational efficiency and reduce human error.\n\n## 2. Infiniticube's Expertise in Fintech App Development\nInfiniticube is a technology company specializing in AI development and fintech app development. While specific projects are not detailed, the company is well-versed in industry trends such as AI-driven personalization, blockchain integration, and the emergence of superapps. Their expertise positions them as a leader in creating secure mobile banking applications tailored for small and medium-sized businesses.\n\n### Infiniticube's Approach to Fintech App Development\nInfiniticube employs a user-centric design approach, ensuring that the apps they develop not only meet technical requirements but also provide a seamless user experience. For instance, they might implement AI-driven features that allow users to manage their finances through voice commands, making the app more accessible. Additionally, Infiniticube focuses on agile development methodologies, allowing for iterative improvements based on user feedback and market trends.\n\n## 3. Factors Influencing the Cost of Fintech Mobile App Development\nThe cost of developing a fintech mobile app in 2025 is influenced by various factors:\n- **App Complexity**: Advanced features increase development time and costs. For example, an app with real-time transaction capabilities will require more extensive testing and security measures. A complex app may take several months to develop, leading to higher costs.\n- **Platform Choice**: Costs vary between iOS and Android development. Developing for both platforms can double the initial investment. Businesses must decide whether to prioritize one platform or invest in cross-platform development to reach a wider audience.\n- **Feature Set**: Incorporating technologies like AI and blockchain raises expenses. Each additional feature can add thousands to the overall cost. For instance, integrating a secure payment gateway can significantly impact the budget.\n- **Security Requirements**: Compliance with regulations and security measures adds to costs. For instance, implementing multi-factor authentication can increase development time and expenses. Financial apps must adhere to strict regulations to protect user data.\n- **Integration with Third-Party Services**: Increases complexity and expense. Integrating payment gateways or KYC services can significantly impact the budget. Businesses should consider the costs associated with these integrations when planning their app development.\n- **Developer Location**: Costs vary based on the developer's geographical location. Hiring developers in regions with higher living costs can inflate the budget. Outsourcing development to countries with lower labor costs can be a viable option for some businesses.\n- **Developer Experience**: Highly experienced developers command higher fees. However, their expertise can lead to a more efficient development process, potentially saving costs in the long run. Investing in skilled developers can result in a higher-quality product.\n- **Maintenance and Updates**: Ongoing costs for app upkeep. Regular updates are essential for security and functionality, adding to the overall budget. Businesses should allocate a portion of their budget for ongoing maintenance to ensure the app remains competitive.\n- **Scalability**: Ensuring the app can grow with user demand increases initial costs. A scalable architecture is crucial for long-term success. Businesses should consider future growth when designing their app.\n- **UI/UX Design**: A well-designed app enhances user experience but can be costly. Investing in quality design can lead to higher user retention rates. A user-friendly interface is essential for attracting and retaining customers.\n\n## 4. Cost Estimation for Fintech Mobile App Development in 2025\nCost estimates for fintech mobile app development in 2025 vary widely:\n- **Basic Apps**: $8,000 to $15,000\n- **Medium Apps**: $15,000 to $20,000\n- **Complex Apps**: $25,000+\n- **Feature-Rich Apps**: $70,000 to $125,000\n- **Overall Range**: $30,000 to $350,000\nThese estimates reflect the diverse requirements and technologies involved in the development process. Additionally, businesses should consider potential hidden costs, such as ongoing maintenance, marketing, and compliance fees. It is advisable to set aside a budget for unexpected expenses that may arise during development.\n\n## 5. Conclusion and Contact Information\nIn conclusion, understanding the cost of fintech mobile app development is crucial for businesses looking to invest in this space. Infiniticube offers expertise in creating secure and innovative fintech applications. For detailed quotes or consultations, please contact Infiniticube at:\n- **Website**: [Infiniticube](https://infiniticube.com/)\n- **Email**: info@infiniticube.com\n- **Phone**: +1 415-800-2907, 09899242016\n- **Address**: D9, Ground Floor, D Block, Sector 3, Noida, Uttar Pradesh 201301, India.",
  };
  let title =
    "# How Infiniticube is Revolutionizing SMBs with Gen AI Products\n\n## Introduction to Infiniticube and Gen AI\nInfiniticube stands at the forefront of AI solutions for businesses, specializing in innovative, technology-driven solutions that enhance operational efficiency, customer experiences, and decision-making processes. In today's technological landscape, Generative AI (Gen AI) has emerged as a pivotal force, enabling businesses to automate tasks, personalize customer interactions, and derive actionable insights from data. Infiniticube's commitment to providing tailored solutions for small and medium-sized businesses (SMBs) positions it as a leader in this transformative field.\n\nThe significance of Gen AI cannot be overstated. It is revolutionizing industries by enabling companies to create content, design products, and automate processes that were once time-consuming and labor-intensive. For instance, businesses are leveraging Gen AI for content creation, product design, and document automation, which enhances productivity and reduces operational costs. Infiniticube recognizes this trend and aims to empower SMBs to harness the potential of Gen AI effectively.\n\nInfiniticube has received several awards and recognitions in the AI industry, establishing its credibility as a trusted partner for businesses looking to innovate and grow.\n\nHowever, many SMBs face challenges such as limited resources, lack of technical expertise, and difficulty in integrating new technologies. Infiniticube addresses these challenges by providing comprehensive support and tailored solutions that enable SMBs to thrive in a competitive landscape.\n\n## Infiniticube's Services for SMBs\nInfiniticube offers a comprehensive suite of services designed to meet the unique needs of SMBs. Their AI solutions encompass machine learning (ML) model development, software development, and product development. By focusing on client-centric personalization, agile development, and continuous improvement through data analytics and knowledge sharing, Infiniticube ensures that SMBs can leverage the full potential of AI technologies.\n\nOne of the standout features of Infiniticube's offerings is their DevOps consulting services. These services enhance performance and streamline systems, making it easier for businesses to adopt and integrate new technologies. For example, a retail SMB that partnered with Infiniticube saw a 30% increase in operational efficiency after implementing their DevOps solutions, which optimized their supply chain management and reduced downtime.\n\nInfiniticube also provides ongoing support during the integration process, ensuring that businesses can smoothly transition to AI solutions without disrupting their existing operations. This support includes training sessions, technical assistance, and regular check-ins to address any challenges that may arise.\n\nTo stay updated with the latest AI trends and technologies, Infiniticube invests in continuous learning and development, ensuring that their services remain relevant and effective in a rapidly evolving market.\n\n## Developing Gen AI Products with Infiniticube\nInfiniticube plays a crucial role in assisting SMBs in developing Gen AI products. They provide personalized and scalable solutions that cater to specific business needs. Predictive analytics is a key component of their approach, allowing businesses to forecast trends and optimize their operations. Recent studies indicate that 53% of SMBs prioritize AI adoption, a significant increase from 41% in April 2023, highlighting the growing importance of AI in the SMB sector.\n\nFor instance, a financial services SMB utilized Infiniticube's predictive analytics to better understand customer behavior, leading to a 25% increase in customer retention rates. This demonstrates how tailored AI solutions can directly impact business outcomes.\n\nThe customization process for Gen AI products is thorough, with Infiniticube working closely with clients to understand their unique business models and challenges. This collaborative approach ensures that the solutions provided are not only effective but also aligned with the clients' strategic goals. Infiniticube also collaborates with other tech companies and partners to enhance their Gen AI offerings, ensuring that they provide the best solutions available.\n\n## Deploying Gen AI Products with Infiniticube\nThe deployment of Gen AI products is a critical phase where Infiniticube's expertise shines. They ensure a seamless deployment process, coupled with ongoing support to empower SMBs in leveraging cutting-edge technology effectively. Generative AI is increasingly being utilized to automate tasks such as data entry and report generation, freeing up valuable time for businesses to focus on strategic initiatives.\n\nInfiniticube follows a structured deployment process that includes initial assessments, solution design, implementation, and post-deployment support. This approach ensures that SMBs can transition smoothly to using Gen AI technologies without disrupting their existing operations. Testimonials from clients highlight the effectiveness of this process, with one client stating, \"Infiniticube made our transition to AI seamless, allowing us to focus on growth rather than technical challenges.\"\n\nInfiniticube utilizes specific tools and platforms during the deployment process, such as cloud-based solutions and advanced analytics software, which set them apart from competitors. However, deploying Gen AI products can come with challenges, such as resistance to change and the need for employee training. Infiniticube mitigates these issues by providing comprehensive training programs and change management strategies that help employees adapt to new technologies and processes.\n\n## Case Studies and Success Stories\nInfiniticube has a proven track record of helping SMBs successfully develop and deploy Gen AI products. For instance, businesses in the Information/Media and Financial Services sectors have reported significant improvements in operational efficiency and customer experiences after implementing Infiniticube's solutions. These success stories illustrate the competitive advantage gained by adopting Gen AI technologies.\n\nOne notable case involved a media company that utilized Infiniticube's AI solutions to automate content generation. As a result, they were able to produce high-quality articles at a rate 50% faster than before, significantly increasing their content output and audience engagement. Another example is a healthcare SMB that implemented predictive analytics to streamline patient management, resulting in a 40% reduction in appointment cancellations.\n\nClients have praised Infiniticube not only for their innovative solutions but also for their exceptional customer service, with feedback highlighting the responsiveness and expertise of the support team.\n\n## Conclusion and Future Prospects\nPartnering with Infiniticube for Gen AI product development offers numerous benefits for SMBs, including enhanced operational efficiency, improved customer experiences, and data-driven decision-making. As the SMB sector continues to evolve, the future prospects for Gen AI products remain bright. By 2026, half of medium-sized businesses in the Asia Pacific region plan to utilize Gen AI applications for marketing and sales, underscoring the importance of staying competitive in this rapidly changing landscape.\n\nIn conclusion, SMBs are encouraged to explore Infiniticube's offerings to harness the power of AI and secure their place in the future of business. With the right partnership, businesses can not only survive but thrive in the age of Gen AI. Infiniticube invites interested SMBs to schedule a free consultation to discuss how their tailored solutions can drive growth and innovation. For more information, please contact Infiniticube at info@infiniticube.com or call +1 415-800-2907.";
  const getRowStatus = (status) => {
    if (status <= 1) {
      return "Pending";
    } else if (status == 2) {
      return "Completed";
    } else {
      return "Failed";
    }
  };
  let login_data = JSON.parse(localStorage.getItem("login_data"));
  async function handleTwitterLogin() {
    try {
      window.open(
        `${process.env.REACT_APP_BASE_USER_URL}/auth/twitter/${
          login_data?.resp_user?.id
        }?redirect_uri=${window.location.origin + window.location.pathname}`,
        "_self"
      );
    } catch (error) {
      console.error("Error initiating Twitter login", error);
    }
  }
  clog(window.location.pathname, "window.location.pathname");
  const integrateLinkedIn = async () => {
    // clog(id);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/linkedin/auth`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      if (!response.data.error) {
        localStorage.setItem("linkedin_navigation", window.location.pathname);
        window.open(response.data.url, "_self");
      } else {
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    }
  };
  const [postingOnLinkedIn, setpostingOnLinkedIn] = useState(false);
  const postLinkedIn = async (code) => {
    // clog(id);
    setpostingOnLinkedIn(true);
    if (!localStorage.getItem("linkedin_access")) {
      setpostingOnLinkedIn(false);
      return;
    }
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/linkedin/post`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          message: linkedInPostMessage,
          access_token: JSON.parse(localStorage.getItem("linkedin_access"))
            ?.access_token,
          image_url: "",
        },
      });
      if (response.data.status) {
        // window.open(response.data.url, "_self");
        localStorage.setItem("linkedin_access", JSON.stringify(response.data));
        // setTimeout(() => {
        //   navigate("/integrations");
        // }, 100);
      } else {
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setpostingOnLinkedIn(false);
    }
  };
  useEffect(() => {
    checkTwitterAccess(setTwitterProfile, setisChecking);
    const searchParams = new URLSearchParams(window.location.search);
    let success = searchParams.get("success");
    //parse success to bool
    success = success === "true" ? true : false;
    // if (success) {
    //   setsuccessFailureMessage("X authentification successful");
    //   setopenSuccessModal("dismissible");
    // }
    const error = searchParams.get("error");
    //if searchparams are present then update the twitter access token
    if (searchParams.has("success")) {
      if (!success) {
        clog("error from query", error);
        // setopenFailureModal("dismissible");
        // setsuccessFailureMessage(error);
      }
    }
  }, []);
  // Add this useEffect near your other hooks
  useEffect(() => {
    if (generateClicked?.open || openXPopup?.open) {
      return;
    }
    const handleMouseLeave = () => {
      setselectedRowIndex(null);
    };

    // Add event listener to the table ref
    if (tableRef.current) {
      tableRef.current.addEventListener("mouseleave", handleMouseLeave);
    }

    // Cleanup function
    return () => {
      if (tableRef.current) {
        tableRef.current.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [tableRef, generateClicked?.open, openXPopup?.open]); // Only re-run if tableRef changes

  clog(rowsData, "rowsData");
  return (
    <>
      <div className="h-full">
        <div className="editable-table-container ">
          <div className="editable-table editable-table-agent" ref={tableRef}>
            <table>
              <thead>
                <tr>
                  <th
                    style={{
                      resize: "none",
                    }}
                  >
                    <div className="header-content">S.No</div>
                  </th>
                  {headerData.map((header, colIndex) => (
                    <th
                      key={colIndex}
                      onDoubleClick={(e) => {
                        if (newColumnsList[colIndex]?.new) {
                          setrenameClicked(false);
                          setnewColumnsList((prevData) =>
                            prevData.map((item, index) =>
                              index === colIndex
                                ? {
                                    ...item,
                                    head_name: headerData[colIndex],
                                  }
                                : item
                            )
                          );
                          setaddColumnClicked(false);
                          handleCellClick(0, colIndex);
                        }
                      }}
                      style={{
                        position: "relative",
                        resize: "none",
                        overflow: "visible",
                        minWidth: "198px",
                        backgroundColor:
                          editingCell?.rowIndex === 0 &&
                          editingCell?.colIndex === colIndex &&
                          "#097ba9",
                        color:
                          editingCell?.rowIndex === 0 &&
                          editingCell?.colIndex === colIndex &&
                          "#fff",
                      }}
                      className="select-none"
                    >
                      {newColumnsList[colIndex]?.new &&
                        editingCell?.rowIndex === 0 &&
                        editingCell?.colIndex === colIndex && (
                          <div
                            className="w-[178px] rounded-[10px] p-[10px] absolute bg-white"
                            style={{
                              boxShadow: "0px 3px 4px 0px #0000000f",
                              position: "absolute",
                              top: "55px",
                              left: "10px",
                              zIndex: "10",
                            }}
                          >
                            <ul>
                              {renameClicked && (
                                <li className="mb-2">
                                  <>
                                    <input
                                      type="text"
                                      id="lname"
                                      name="lname"
                                      placeholder="Enter name"
                                      value={
                                        newColumnsList[colIndex]?.head_name
                                      }
                                      className="w-full border-0 focus:ring-0 text-black"
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        e.nativeEvent.stopImmediatePropagation();

                                        setnewColumnsList((prevData) =>
                                          prevData.map((item, index) =>
                                            index === colIndex
                                              ? {
                                                  ...item,
                                                  head_name: e.target.value,
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                    />
                                    <hr />
                                    <button
                                      type="button"
                                      className="flex items-center w-full bg-[#097BA9] rounded-full text-[#fff] py-1 flex items-center justify-center hover:bg-[#085b7ced] duration-200 mt-2"
                                      onClick={() => {
                                        // callSaveApi();
                                        setrenameClicked(false);
                                      }}
                                    >
                                      Update
                                    </button>
                                  </>
                                  <hr />
                                </li>
                              )}
                              {!renameClicked && (
                                <li className="mb-2">
                                  <button
                                    type="button"
                                    className="flex items-center w-full text-black hover:text-[#097BA9]"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.nativeEvent.stopImmediatePropagation();
                                      setrenameClicked(true);
                                    }}
                                  >
                                    <svg className="icon me-2">
                                      <use href="#icon_edit"></use>
                                    </svg>
                                    Rename Column
                                  </button>
                                </li>
                              )}
                              <li>
                                <button
                                  type="button"
                                  className="flex items-center w-full text-black hover:text-[#097BA9]"
                                  // onClick={deleteSelectedCols}
                                >
                                  <svg className="icon me-2">
                                    <use href="#icon_delete_tbl"></use>
                                  </svg>
                                  Delete
                                </button>
                              </li>
                            </ul>
                          </div>
                        )}

                      <div className="header-content">
                        {capitalizeWords(header)}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {agentResponseData?.map((row, rowIndex) => (
                  <tr
                    key={rowIndex + 1}
                    ref={
                      rowIndex === agentResponseData.length - 1
                        ? lastElementRef
                        : null
                    }
                    style={{
                      position: "relative",
                      backgroundColor:
                        selectedRowIndex === rowIndex
                          ? "#e9f2ff"
                          : "transparent",
                    }}
                    onMouseEnter={() => {
                      setselectedRowIndex(rowIndex);
                    }}
                  >
                    {/* Table Columns */}
                    <td className="abs-td relative">
                      <div
                        className="content-container"
                        style={{
                          justifyContent: "center",
                        }}
                      >
                        <div className="content">{rowIndex + 1}</div>
                      </div>
                    </td>
                    <td className="abs-td relative">
                      <div className="content-container flex items-center justify-between px-2">
                        <div className="row-content">{row?.input_content}</div>
                        <button
                          className={`px-4 py-1 rounded-[10px] text-white ${
                            row?.status <= 1
                              ? "bg-gray-400 cursor-not-allowed opacity-50"
                              : "bg-[#097BA9] hover:bg-[#086891]"
                          }`}
                          onClick={() => {
                            if (checkKnowledgeBase()) {
                              setselectedRow(row);
                              settaskData({
                                ...taskData,
                                content: row?.input_content,
                              });
                              setrerunPopup(true);
                            }
                            clog("Rerun", row);
                          }}
                          disabled={row?.status <= 1}
                        >
                          Re Run
                        </button>
                      </div>
                    </td>
                    <td className="abs-td relative">
                      <div className="content-container">
                        <div
                          style={{
                            textAlign: "left",
                          }}
                        >
                          {row?.title}
                        </div>
                      </div>
                    </td>
                    <td className="abs-td relative">
                      <div className="content-container">
                        <div
                          style={{
                            textAlign: "left",
                          }}
                          className="row-content"
                          dangerouslySetInnerHTML={{
                            __html: row?.content
                              ? row.content.length > 100
                                ? getRemarkableText(row.content).slice(0, 100) +
                                  "..."
                                : getRemarkableText(row.content)
                              : "",
                          }}
                        />
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            setselectedRow(row);
                            setstringOutputContent(
                              `${
                                row?.content || ""
                              } \n\n Written by AI Employee [Mark](https://vison.ai/ai-employee/mark)`
                            );
                            // setstringOutputContent(
                            //   `## How Infiniticube is Revolutionizing SMBs with Gen AI Products\n\n### Introduction to Infiniticube and Gen AI\n\nIn the rapidly evolving world of technology, Generative AI (Gen AI) is emerging as a transformative force, reshaping industries and redefining business strategies. Infiniticube, a leader in AI development services, is at the forefront of this revolution, crafting tailored solutions using [Azure IoT](https://azure.microsoft.com/en-us/services/iot/) and [AWS IoT](https://aws.amazon.com/iot/). With expertise in both cloud computing and traditional data centers, Infiniticube ensures that businesses can optimize their IT infrastructure for success. The global Gen AI market size was valued at USD 17.65 billion in 2023 and is expected to reach USD 803.90 billion by 2033, growing at a CAGR of 46.5% from 2024 to 2033. This growth underscores the increasing importance of Gen AI in today's market.\n\n### Leveraging Advanced Technologies for SMBs\n\nInfiniticube leverages cutting-edge technologies like [TensorFlow](https://www.tensorflow.org/), [PyTorch](https://pytorch.org/), and [Scikit-learn](https://scikit-learn.org/stable/) to create tailored solutions for SMBs. These technologies enable businesses to harness the power of machine learning and deep learning, driving innovation and efficiency. According to a Techaisle Survey, 55% of SMBs are already exploring GenAI, and another 20% are planning to do so soon. By utilizing these advanced tools, Infiniticube empowers SMBs to stay competitive in a fast-paced market, offering solutions that are both scalable and adaptable to changing needs.\n\n### Tailored Solutions on Azure IoT and AWS IoT\n\nInfiniticube's expertise in [Azure IoT](https://azure.microsoft.com/en-us/services/iot/) and [AWS IoT](https://aws.amazon.com/iot/) platforms allows them to create customized solutions that cater to the unique needs of SMBs. These platforms provide the flexibility and scalability required to implement Gen AI solutions effectively. SMBs are using Gen-AI to automate tasks such as data entry, report generation, and email management, which frees up valuable time and resources for more strategic initiatives. This automation not only enhances productivity but also allows businesses to focus on innovation and growth.\n\n### Enhancing SMB Products and Services\n\nInfiniticube's expertise in AI development and ML model creation enhances SMB products and services, providing a competitive edge. A Salesforce Survey indicates that 91% of SMBs with AI report a revenue boost, showcasing the significant impact of AI on business growth. By integrating AI into their operations, SMBs can improve customer experiences, streamline processes, and drive revenue. Infiniticube's tailored solutions ensure that these benefits are realized, helping businesses to thrive in an increasingly digital world.\n\n### 24/7 Support and IT Infrastructure Optimization\n\nInfiniticube offers 24/7 support and IT infrastructure services to ensure seamless operations. This support is crucial for SMBs, as it provides the technical expertise needed to navigate the complexities of AI adoption. Despite the benefits, only 52% of SMBs using AI invest in training their workforce, which highlights the need for comprehensive support and guidance. Infiniticube addresses this gap by offering ongoing support and training, ensuring that businesses can leverage AI effectively and confidently.\n\n### Conclusion: The Future of Gen AI in SMBs\n\nThe future of Gen AI in SMBs is promising, with potential for enhancing operations and driving innovation. By 2026, half of medium-sized businesses in Asia/Pacific, excluding Japan, will be using GenAI-based applications. Infiniticube is well-positioned to lead this transformation, providing SMBs with the tools and expertise needed to thrive in the evolving digital landscape. As businesses continue to embrace Gen AI, the role of companies like Infiniticube will be pivotal in shaping the future of industries worldwide.\n\nFor more information, you can reach out to Infiniticube via [Email](mailto:info@infiniticube.com) or visit their [website](https://www.infiniticube.com).", "critic_review": "The blog effectively covers the topic of how Infiniticube is aiding SMBs in developing and deploying Gen AI products. It successfully incorporates the required keywords and follows the given outline. The content is now expanded to meet the 500-word requirement, providing a comprehensive overview of Infiniticube's services and the benefits of Gen AI for SMBs. The inclusion of statistics and examples enhances the credibility and depth of the article. The URLs and email are correctly embedded, making the blog informative and engaging. Overall, the blog meets the user requirements and aligns with the company's advertising goals.`
                            // );
                            setcloseOpenContent(true);
                          }}
                          className="editable-cell-button "
                        >
                          <svg className="icon">
                            <use href="#icon_arrows-angle-expand"></use>
                          </svg>
                        </Button>
                      </div>
                    </td>
                    <td>
                      <div
                        className="content-container"
                        style={{
                          justifyContent: "center",
                          height: "100%",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "500",
                            color: row?.status === 2 ? "#5D9C46" : "#EB9C43",
                          }}
                        >
                          {getRowStatus(row?.status)}
                        </div>
                      </div>
                    </td>
                    <td className="abs-td relative">
                      <div className="content-container">
                        <div>{""}</div>
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            setstringOutput(row?.keywordseeds);
                            setcloseOpen(true);
                          }}
                          className="editable-cell-button active"
                        >
                          <svg className="icon">
                            <use href="#icon_arrows-angle-expand"></use>
                          </svg>
                        </Button>
                      </div>
                    </td>
                    <td className="abs-td relative">
                      <div className="content-container">
                        <div>{""}</div>
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenUrl(true);
                            setPublishedUrls(row?.cmspublished);
                          }}
                          className="editable-cell-button active"
                        >
                          <svg className="icon">
                            <use href="#icon_arrows-angle-expand"></use>
                          </svg>
                        </Button>
                      </div>
                    </td>
                    <td className="abs-td relative"></td>
                    <td className="abs-td relative"></td>
                    <td className="abs-td relative">
                      <div className="content-container px-2">
                        <div
                          style={{
                            textAlign: "left",
                          }}
                          className="row-content"
                          dangerouslySetInnerHTML={{
                            __html: row?.content
                              ? row.content.length > 100
                                ? getRemarkableText(row.content).slice(0, 100) +
                                  "..."
                                : getRemarkableText(row.content)
                              : "",
                          }}
                        />
                        <button
                          className={`px-4 py-1 rounded-[10px] text-white ${
                            row?.status <= 1 || row?.status > 2
                              ? "bg-gray-400 cursor-not-allowed opacity-50"
                              : "bg-[#097BA9] hover:bg-[#086891]"
                          }`}
                          onClick={() => {
                            if (!twitterProfile) {
                              setConnectModal("dismissible");
                              return;
                            }
                            setselectedRow(row);
                            setedited(false);
                            if (row?.twitter && row?.twitter?.length > 0) {
                              setgenerateClicked({
                                open: true,
                                headline: "Tweets",
                                title: "Generate Tweets",
                              });
                              settweets(row?.twitter);
                              settweetsModified(row?.twitter);
                            } else {
                              setopenXPopup({
                                open: true,
                                type: "Twitter",
                                title: "Generate Tweets",
                                headline: "Number Of Tweets To Generate",
                              });
                            }
                          }}
                          disabled={row?.status <= 1 || row?.status > 2}
                        >
                          Publish
                        </button>
                      </div>
                    </td>
                    <td className="abs-td relative">
                      <div className="content-container px-2">
                        <div
                          style={{
                            textAlign: "left",
                          }}
                          className="row-content"
                          dangerouslySetInnerHTML={{
                            __html: row?.content
                              ? row.content.length > 100
                                ? getRemarkableText(row.content).slice(0, 100) +
                                  "..."
                                : getRemarkableText(row.content)
                              : "",
                          }}
                        />
                        <button
                          className={`px-4 py-1 rounded-[10px] text-white ${
                            row?.status <= 1 || row?.status > 2
                              ? "bg-gray-400 cursor-not-allowed opacity-50"
                              : "bg-[#097BA9] hover:bg-[#086891]"
                          }`}
                          disabled={row?.status <= 1 || row?.status > 2}
                          onClick={() => {
                            if (!localStorage.getItem("linkedin_access")) {
                              setlinkedInConnectModal("dismissible");
                              return;
                            }
                            setselectedRow(row);
                            setedited(false);
                            if (row?.linkedin && row?.linkedin?.length > 0) {
                              setgenerateClicked({
                                open: true,
                                headline: "LinkedIn",
                                title: "Generate LinkedIn Post",
                              });
                              settweets(row?.linkedin);
                              settweetsModified(row?.linkedin);
                            } else {
                              setopenXPopup({
                                open: true,
                                type: "LinkedIn",
                                title: "Generate LinkedIn Post",
                                headline: "Number Of LinkedIn To Generate",
                              });
                            }
                            // postLinkedIn();
                          }}
                        >
                          Publish
                        </button>
                      </div>
                    </td>
                    {loadingIndividualAgent == row?.id && (
                      <div className="row-loader">
                        <Loader />
                      </div>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* <Modal
          show={closeOpenContent}
          size="7xl"
          onClose={() => setcloseOpenContent(false)}
          popup
        >
          <Modal.Header />
          <Modal.Body>
            <div>
              <TextEditor
                stringOutput={stringOutputContent}
                setstringOutput={setstringOutputContent}
                from="knowledgebase"
              />
            </div>
          </Modal.Body>
        </Modal> */}
        <Drawer
          open={closeOpenContent}
          onClose={() => setcloseOpenContent(false)}
          position="right"
          className="w-[82%] ai-empCan p-0 bg-transparent"
        >
          {/* <Drawer.Header className="pt-3 pb-3 bg-white"></Drawer.Header> */}
          <Drawer.Items className="">
            <TextEditor
              title={selectedRow?.title}
              content={selectedRow?.content}
              stringOutput={stringOutputContent}
              selectedRow={selectedRow}
              setstringOutput={setstringOutputContent}
              from="agent"
              setsuccessFailureMessage={setsuccessFailureMessage}
              setopenSuccessModal={setopenSuccessModal}
              setopenFailureModal={setopenFailureModal}
              setcloseOpenContent={setcloseOpenContent}
              callSaveApi={callSaveApi}
            />
          </Drawer.Items>
        </Drawer>
        <Modal
          show={rerunPopup}
          size="3xl"
          onClose={() => setrerunPopup(false)}
          popup
          className=""
        >
          <Modal.Header className="pb-0 mb-0"></Modal.Header>
          <Modal.Body className="">
            <h2 className="text-[25px] font-[500] text-center">Re Run</h2>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                getAgentData(selectedRow?.id);
              }}
            >
              <div className="mb-6">
                <Label
                  htmlFor="message"
                  className="mb-2 block text-[20px] font-[400]"
                >
                  Create Content About / Instructions *
                </Label>
                <textarea
                  className="border rounded-[12px] shadow-sm w-[700px] px-4  border-[#E9EBF0] text-[16px] font-[400]"
                  id="content"
                  name="content"
                  placeholder="Enter"
                  rows={4}
                  required
                  value={taskData?.content}
                  onChange={handleChangeInput}
                />
              </div>
              {/* <div className="mb-6 w-[700px]">
                <label
                  className="block text-[20px] font-[400] mb-2"
                  htmlFor="tags"
                >
                  Enter Keywords
                </label>
                <div className="flex flex-wrap items-center bg-[#FFFFFF] px-2 py-1 rounded-[15px] border border-gray-300 shadow-md tags-input">
                  {tagskeywords.map((tag, index) => (
                    <div
                      key={index}
                      className="bg-blue-500 text-white text-sm px-3 py-1 rounded-full mr-2 my-1 flex items-center"
                    >
                      {tag}
                      <button
                        className="ml-2 text-white font-bold"
                        onClick={() => removeTagkeywords(index)}
                      >
                        &times;
                      </button>
                    </div>
                  ))}
                  <input
                    type="text"
                    className="flex-grow p-2"
                    placeholder="Type and press Enter"
                    value={inputValuekeywords}
                    onChange={(e) => setInputValuekeywords(e.target.value)}
                    onKeyDown={handleKeyDownkeywords}
                  />
                </div>
              </div> */}
              <div className="mb-6 w-[700px]">
                <button
                  type="submit"
                  className="py-2 h-[54px] w-full rounded-full text-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 mb-[30px] flex items-center justify-center"
                  disabled={loading}
                  // onClick={getAgentData}
                >
                  {loading ? (
                    <div className="flex gap-2 justify-center">
                      <span>Running Task</span>
                      <ThreeDotsLoader />
                    </div>
                  ) : (
                    "Run Task"
                  )}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <Drawer
          open={openXPopup?.open}
          onClose={() => setopenXPopup({})}
          position="right"
          className="p-0 w-[580px] notification-canvas"
        >
          <Drawer.Header
            title={openXPopup?.title}
            className="pt-3 border border-bottom"
          />
          <Drawer.Items className="h-[92%] flex items-center">
            <div className="px-5 pb-5 w-full">
              <p className="text-center text-[18px] font-[500] pb-4">
                {openXPopup?.headline}
              </p>
              <select
                className="border rounded-full shadow-sm w-full h-[50px] px-4 text-[16px] font-[400]  mb-4"
                id="subject"
                name="subject"
                value={numberOfTweets}
                onChange={(e) => setnumberOfTweets(e.target.value)}
              >
                <option value="" disabled>
                  Select an option
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
              <button
                type="button"
                className="py-2 h-[54px] w-full rounded-full text-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-[#fff] hover:transition hover:delay-75 mb-[30px] flex items-center justify-center"
                disabled={generatingTweet || !numberOfTweets}
                onClick={() => {
                  // setopenXPopup(false);
                  // setgenerateClicked(true);
                  callGenerateFn(openXPopup?.type, openXPopup?.title);
                }}
              >
                {generatingTweet ? (
                  <div className="flex gap-2 justify-center">
                    <span>Generating</span>
                    <ThreeDotsLoader />
                  </div>
                ) : (
                  "Generate"
                )}
              </button>
            </div>
          </Drawer.Items>
        </Drawer>
        <Drawer
          open={generateClicked?.open}
          onClose={() => {
            if (edited) {
              callSaveApi(tweetsModified, generateClicked?.headline);
              setedited(false);
            }
            setgenerateClicked({});
          }}
          ref={drawerRef}
          position="right"
          className={`p-0 w-[600px] notification-canvas`}
        >
          <Drawer.Header
            title={generateClicked?.title}
            className="pt-3 border border-bottom"
          />
          <Drawer.Items className="flex items-center">
            <div className="w-full mx-5 pt-[20px]">
              <p className="text-[18px] font-[500] pb-2">
                {generateClicked?.headline}
              </p>
              {tweets?.map((tweet, index) => (
                <div className="mb-4 mx-auto" key={index}>
                  <TweetCard
                    headline={generateClicked?.headline}
                    profile={getData(generateClicked?.headline)?.profile}
                    stringOutput={tweet?.content}
                    tweet={tweet}
                    tweets={tweets}
                    settweets={settweets}
                    tweetsModified={tweetsModified}
                    settweetsModified={settweetsModified}
                    edited={edited}
                    setedited={setedited}
                    cardNumber={index}
                    // wholeStringOutput={stringOutput}
                    // mediaObj={
                    //   selectedFile?.content_settings?.media_arr
                    //     ? selectedFile?.content_settings?.media_arr[index]
                    //     : null
                    // }
                    // isTweetPosted={
                    //   selectedFile?.content_settings?.posted_tweets_arr
                    //     ? selectedFile?.content_settings?.posted_tweets_arr[
                    //         index
                    //       ]
                    //     : null
                    // }
                    // wholeStringOutput={
                    //   stringOutput || selectedFile?.contents
                    // }
                    // media_arr={
                    //   selectedFile?.content_settings?.media_arr || []
                    // }
                    key={index}
                    content_id={selectedRow?.id}
                    // loader={loader}
                    setopenFailureModal={setopenFailureModal}
                    setopenSuccessModal={setopenSuccessModal}
                    setsuccessFailureMessage={setsuccessFailureMessage}
                    handleTwitterLogin={
                      getData(generateClicked?.headline)?.method
                    }
                    setStringOutput={setstringOutput}
                    // setstringWords={setstringWords}
                    connectModal={
                      generateClicked?.headline === "Tweets"
                        ? connectModal
                        : linkedInconnectModal
                    }
                    setConnectModal={
                      generateClicked?.headline === "Tweets"
                        ? setConnectModal
                        : setlinkedInConnectModal
                    }
                    callSaveApi={callSaveApiUpdate}
                  />
                </div>
              ))}
            </div>
          </Drawer.Items>
        </Drawer>

        <Modal
          show={false}
          size="7xl"
          onClose={() => setopenXPopup(false)}
          popup
        >
          <Modal.Header />
          <Modal.Body>
            <div>
              {["1", "2", "3"].map((string, index) => (
                <TweetCard
                  profile={twitterProfile}
                  stringOutput={string}
                  cardNumber={index}
                  // wholeStringOutput={stringOutput}
                  // mediaObj={
                  //   selectedFile?.content_settings?.media_arr
                  //     ? selectedFile?.content_settings?.media_arr[index]
                  //     : null
                  // }
                  // isTweetPosted={
                  //   selectedFile?.content_settings?.posted_tweets_arr
                  //     ? selectedFile?.content_settings?.posted_tweets_arr[
                  //         index
                  //       ]
                  //     : null
                  // }
                  // wholeStringOutput={
                  //   stringOutput || selectedFile?.contents
                  // }
                  // media_arr={
                  //   selectedFile?.content_settings?.media_arr || []
                  // }
                  key={index}
                  // content_id={selectedFile?.id}
                  // loader={loader}
                  setopenFailureModal={setopenFailureModal}
                  setopenSuccessModal={setopenSuccessModal}
                  setsuccessFailureMessage={setsuccessFailureMessage}
                  handleTwitterLogin={handleTwitterLogin}
                  setStringOutput={setstringOutput}
                  // setstringWords={setstringWords}
                />
              ))}
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={closeOpen}
          size="7xl"
          onClose={() => setcloseOpen(false)}
          popup
        >
          <Modal.Header />
          <Modal.Body>
            <div>
              <div className="editable-table-container">
                <div className="editable-table">
                  <table style={{ tableLayout: "fixed" }}>
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }}>S.No</th>
                        <th style={{ width: "25%" }}>Keyword</th>
                        <th style={{ width: "25%" }}>
                          Monthly Average Search Volume
                        </th>
                        <th style={{ width: "25%" }}>
                          Keyword Difficulty (Competition)
                        </th>
                        <th style={{ width: "25%" }}>
                          Keyword Difficulty score <br /> (Competition Index)
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <table style={{ tableLayout: "fixed", width: "100%" }}>
                      <tbody>
                        {stringOutput?.map((item, index) => (
                          <tr key={index}>
                            <td style={{ width: "5%" }}>{index + 1}</td>
                            <td style={{ width: "25%" }}>{item?.keyword}</td>
                            <td style={{ width: "25%" }}>
                              {item?.avgMonthlySearches}
                            </td>
                            <td style={{ width: "25%" }}>
                              {item?.competition}
                            </td>
                            <td style={{ width: "25%" }}>
                              {item?.competitionIndex}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={openUrl}
          size="7xl"
          onClose={() => {
            setOpenUrl(false);
            setPublishedUrls([]);
          }}
          popup
        >
          <Modal.Header />
          <Modal.Body>
            <div>
              <div className="editable-table-container">
                <div className="editable-table">
                  <table style={{ tableLayout: "fixed" }}>
                    <thead>
                      <tr>
                        <th style={{ width: "25%" }}>Social Type</th>
                        <th style={{ width: "75%" }}>Published URL</th>
                      </tr>
                    </thead>
                  </table>
                  <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <table style={{ tableLayout: "fixed", width: "100%" }}>
                      <tbody>
                        {publishedUrls?.map((item, index) => (
                          <tr key={index}>
                            <td style={{ width: "25%" }}>
                              {item?.social_type?.toUpperCase()}
                            </td>
                            <td style={{ width: "75%" }}>
                              <a href={item?.post_url} target="_blank">
                                {item?.post_url}
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      <SuccessModal
        open={openSuccessModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <FailureModal
        open={openFailureModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <SocialConnectModal
        connectModal={connectModal}
        massage={"You Have Not Connected X To Vison"}
        setConnectModal={setConnectModal}
        onConfirm={handleTwitterLogin}
        from="X"
      />
      <SocialConnectModal
        connectModal={linkedInconnectModal}
        massage={"You Have Not Connected LinkedIn To Vison"}
        setConnectModal={setlinkedInConnectModal}
        onConfirm={integrateLinkedIn}
        from="linkedIn"
      />
    </>
  );
};

export default EditableTableAgent;
